<div
  class="column d-flex align-items-center"
  *ngFor="let key of backendListRender"
>
  <span *ngIf="key.keyName" class="column_label {{ key.className }}"
    >{{ key.keyName }} :</span
  >
  <span
    class="column_value {{ key.className }}"
    [ngClass]="
      key.type == 'status'
        ? item[key.key]?.toLowerCase()
        : key.type == 'link'
        ? 'column_link ' + item[key.key]?.toLowerCase()?.split('.')[0]
        : ''
    "
    [routerLink]="key.type == 'Id' ? ['/analytics/settlement/detail', item[key.key]] : []"
  >
    {{
      key.type == "link"
        ? item[key.key]
        : key.type == "date"
        ? (item[key.key] | date: "MM/dd/yy")
        : key.type == "currency"
        ? '$' +(item[key.key] | number : '1.2-2')
        : item[key.key]
    }}</span
  >
  <div class="d-flex justify-content-end w-100" *ngIf="key.type == 'button'">
    <app-button [buttonSize]="'action'" (click)="redirect()">
      {{ key.key }}
    </app-button>
  </div>
</div>